export interface MapSaveErrorLike {
  data?: { code?: string };
  message?: string;
}

/**
 * Returns an actionable, non-technical recovery message for a boundary save.
 * The map draft remains on screen after a failed mutation, so the guidance must
 * tell staff whether to refresh, correct geometry, or retry without losing work.
 */
export function getMapSaveFeedback(error: MapSaveErrorLike): string {
  if (error.data?.code === "CONFLICT" || error.message?.includes("CONFLICT")) {
    return "ຂອບເຂດຖືກແກ້ໄຂໂດຍຜູ້ອື່ນ. ກະລຸນາ copy ຫຼືບັນທຶກຈຸດອ້າງອີງຂອງທ່ານ, refresh ໜ້າ, ແລ້ວກວດເບິ່ງຂອບເຂດລ່າສຸດກ່ອນລອງໃໝ່.";
  }
  if (error.data?.code === "BAD_REQUEST") {
    return "ຂອບເຂດຍັງບໍ່ຖືກຕ້ອງ. ກະລຸນາກວດເບິ່ງວ່າ polygon ປິດສົມບູນ, ບໍ່ຕັດກັນເອງ, ແລະຢູ່ໃນ ສປປ ລາວ.";
  }
  if (
    error.data?.code === "TIMEOUT" ||
    error.message?.toLowerCase().includes("network") ||
    error.message?.toLowerCase().includes("fetch")
  ) {
    return "ການເຊື່ອມຕໍ່ຂາດຕອນ. ແບບຮ່າງຍັງຢູ່ໃນໜ້ານີ້; ກວດອິນເຕີເນັດແລ້ວກົດ ບັນທຶກ ອີກຄັ້ງ.";
  }
  return "ບໍ່ສາມາດບັນທຶກຂອບເຂດໄດ້. ແບບຮ່າງຍັງຢູ່; ກະລຸນາລອງບັນທຶກອີກຄັ້ງ ຫຼື ຕິດຕໍ່ຜູ້ດູແລລະບົບຖ້າບັນຫາຍັງຢູ່.";
}
